export default __webpack_public_path__ + "1352cb16d26364db1310c36213fb5cae.svg";